function A1() {
    return (
        <main className='main'>
            <h2>Опис трудових функцій; професійні компетентності; знання, уміння та навички</h2>
            <table>
                <tr>
                    <td colspan="3"> А1 Здоров’язбережувальна</td>
                </tr>
                <tr className='bold'>
                    <td>Професійні компетентності (за трудовою дією або групою трудових дій)</td>
                    <td>Знання</td>
                    <td>Уміння та навички</td>
                </tr>
                <tr>
                    <td rowspan="3">
                        А1.1 Здатність забезпечити дотримання правил пожежної безпеки, цивільного захисту та безпеки
                        життєдіяльності, вимог санітарного законодавства, законодавства про безпечність та якість
                        харчових
                        продуктів під час освітнього процесу
                    </td>
                    <td>
                        А.1.1.31 Нормативно-правові, теоретичні, технічні основи пожежної безпеки, цивільного захисту та
                        безпеки
                        життєдіяльності
                    </td>
                    <td>
                        А1.1.У1 Планувати і здійснювати систему заходів щодо захисту учасників освітнього процесу і
                        матеріальних
                        цінностей у разі військових дій, стихійних лих або техногенних катастроф
                    </td>
                </tr>
                <tr>
                    <td>
                        А.1.1.32 Вимоги санітарного законодавства, безпечності та якості харчових продуктів відповідно
                        до
                        принципів Системи управління безпечністю харчових продуктів (НАССР)
                    </td>
                    <td>
                        А1.1.У2 Забезпечувати дотримання вимог безпеки життєдіяльності, санітарного законодавства та
                        організації
                        харчування в закладі дошкільної освіти згідно принципів Системи управління безпечністю харчових
                        продуктів (НАССР)
                    </td>
                </tr>
                <tr>
                    <td>
                        А.1.1.33 Особливості використання здоров’язбе-режувальних технологій в освітньому процесі
                    </td>
                    <td>
                        А1.1.УЗ Використовувати здоров’я збережу вальні технології в освітньому процесі
                    </td>
                </tr>
                <tr>
                    <td rowspan="2">
                        А1.2 Здатність створювати освітнє середовище, вільне від насильства та булінгу
                    </td>
                    <td>
                        А.1.2.31 Нормативно-правові вимоги щодо попередження та протидії булінгу в закладі дошкільної
                        освіти
                    </td>
                    <td>
                        А1.2.У1 Планувати та вживати заходи щодо попередження та протидії булінгу серед учасників
                        освітнього
                        процесу
                    </td>
                </tr>
                <tr>
                    <td>
                        А.1.2.32 Способи міжвідомчої взаємодії закладу дошкільної освіти з іншими органами і службами
                        щодо
                        захисту прав дітей
                    </td>
                    <td>
                        А.1.2.У2 Організовувати міжвідомчу взаємодію закладу дошкільної освіти з іншими органами і
                        службами
                        захисту прав дітей з метою попередження та подолання фізичного, психологічного, емоційного
                        насильства та
                        булінгу
                    </td>
                </tr>
                <tr>
                    <td>
                        А1.3 Здатність до організації діяльності психологічної служби та соціально-педагогічного
                        патронажу в закладі
                        дошкільної освіти
                    </td>
                    <td>
                        А1.3.31 Нормативно-правові основи діяльності психологічної служби та соціально-педагогічного
                        патронажу
                    </td>
                    <td>
                        А1.3.У1 Планувати і забезпечувати ефективну діяльність психологічної служби та
                        соціально-педагогічного
                        патронажу
                    </td>
                </tr>
            </table>
        </main>
    )
}

export {A1}